<template>
<div class="layout">
  <router-view></router-view>
</div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "layout",
  computed:{
    ...mapState({
      staff: state => state.passport.staff
    })
  },
  mounted() {
    this.loadProfile().then(profile=>{
      console.log(profile);
      this.staff.email = profile.data.email;
      this.staff.userId = profile.data.id;
    }).catch((e)=>{
      console.log('失败',e.response)
      this.$router.replace({name:'login'})
    })
  },
  methods: {
    ...mapActions({
      loadProfile: "passport/loadProfile"
    })
  }
}
</script>

<style scoped lang="stylus">
.layout
  width 100%
  height 100%
  background-color: #ffffff
</style>
